export enum Device {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop"
}
